"use client";

import { Map, Marker } from "@vis.gl/react-google-maps";

export function PlaceMap({
  location,
}: {
  location: google.maps.LatLngLiteral;
}) {
  return (
    <div className="aspect-video w-full overflow-hidden rounded-xl">
      <Map defaultCenter={location} defaultZoom={10}>
        <Marker position={location} />
      </Map>
    </div>
  );
}
